import { Injectable } from '@angular/core';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { NotificationType } from '../../model';

@Injectable()
export class AccaBoostTrackingService {
    private readonly baseTrackData = <TrackData>{
        [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'bets boost',
        [trackingConstants.COMPONENT_LABEL_EVENT]: 'acca boost',
        [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
        [trackingConstants.COMPONENT_LOCATION_EVENT]: 'acca boost betslip pop up',
        [trackingConstants.COMPONENT_EVENT_DETAILS]: 'acca boost widget',
        [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
    };

    constructor(private trackingService: TrackingService) {}

    trackLadderInitialBubbleNotifications(notificationType: string, location?: string): void {
        location = this.transformLocationTag(location);
        const eventDetails = notificationType === NotificationType.OneSelectionAway ? 'bubble before one leg minimum' : 'boost ladder';
        this.trackForAccaLadderAndBubble(trackingConstants.EVENT_CONTENT_VIEW, eventDetails, location);
    }

    trackLadderNotificationCloseClicked(accaBoostId: string): void {
        this.track(trackingConstants.EVENT_TRACKING, 'exit', accaBoostId, 'close x');
    }

    trackOneSelectionAwayNotificationCloseClicked(location?: string): void {
        this.setUpTrackingData({
            location: this.transformLocationTag(location),
            eventDetails: 'bubble before one leg minimum',
            actionEvent: 'close',
            positionEvent: NOT_APPLICABLE,
        });
    }

    trackLadderNotificationInfoIconClick(location?: string): void {
        this.setUpTrackingData({
            location: this.transformLocationTag(location),
            eventDetails: 'info icon',
            actionEvent: 'click',
            positionEvent: 'boost ladder',
        });
    }

    private setUpTrackingData(data: { [key: string]: string | undefined }): void {
        const overrides = {
            [trackingConstants.COMPONENT_LOCATION_EVENT]: data.location,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: data.eventDetails,
            [trackingConstants.COMPONENT_ACTION_EVENT]: data.actionEvent,
            [trackingConstants.COMPONENT_POSITION_EVENT]: data.positionEvent,
        };

        const trackingData = { ...this.baseTrackData, ...overrides };
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackGoToBetslip(accaBoostId: string): void {
        this.track(trackingConstants.EVENT_TRACKING, 'click', accaBoostId, 'go to betslip');
    }

    private transformLocationTag(location?: string): string | undefined {
        switch (location) {
            case RouteTag.Lobby:
                location = 'home page';
                break;
            case RouteTag.EventDetails:
                location = 'event details page';
                break;
            case RouteTag.SportLobby:
                location = 'sports page';
                break;
        }

        return location;
    }

    private trackForAccaLadderAndBubble(event: string, eventDetails: string, location?: string): void {
        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'bets boost',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'acca boost',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: location,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'load',
        };
        this.trackingService.track(event, trackingData);
    }

    private track(event: string, action: string, accaBoostId: string, position?: string): void {
        const trackData = {
            ...this.baseTrackData,
            [trackingConstants.COMPONENT_ACTION_EVENT]: action,
            [trackingConstants.COMPONENT_POSITION_EVENT]: position || NOT_APPLICABLE,
            accaBoostId,
        };

        this.trackingService.track(event, trackData);
    }
}
